import { render, staticRenderFns } from "./ComprasVentajas.vue?vue&type=template&id=52bacc0d&scoped=true"
import script from "./ComprasVentajas.vue?vue&type=script&lang=js"
export * from "./ComprasVentajas.vue?vue&type=script&lang=js"
import style0 from "./ComprasVentajas.vue?vue&type=style&index=0&id=52bacc0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bacc0d",
  null
  
)

export default component.exports